import { useEffect } from "react"

import { ROLE_EVENT_ADMIN, ROLE_SITE_ADMIN, ROLE_SUPER_ADMIN } from "shared/constant/lookup/role"
import useFetch from "shared/model/useFetch"
import useRoleCookie from "shared/model/useRoleCookie"

const useGetAdminEvent = () => {
    const [roleCookie] = useRoleCookie()
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        if ([ROLE_SUPER_ADMIN, ROLE_EVENT_ADMIN, ROLE_SITE_ADMIN].includes(roleCookie)) {
            fetchRequest("GET", `/admin/event/list/active`)
        }
    }, [])

    return [fetchResult]
}

export default useGetAdminEvent